<template>
  <div class="list-box common-shadow clearfix">
    <vxe-table
      class="table-style"
      stripe
      highlight-hover-row
      show-footer
      show-overflow
      max-height="540"
      border="none"
      :loading="loading"
      :data="collectionListData"
      :auto-resize="true"
      align="center"
      :footer-method="footerMethod"
      @cell-click="cellClick"
      ref="xTable"
    >
      <vxe-table-column type="seq" title="序号" width="90"></vxe-table-column>
      <vxe-table-column
        field="paymentsNum"
        title="收付款编号"
        class-name="link-text"
        width="130"
      ></vxe-table-column>
      <vxe-table-column field="flowNum" title="流程编号" width="130">
        <template slot-scope="{ row }">
          <span
            @click="openProcedureDetail(row.flowId, 2)"
            style="color: #2d8cf0; cursor: pointer"
            >{{ row.flowNum }}</span
          >
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ownName"
        title="所属方"
        :filters="filterOwnName"
      ></vxe-table-column>
      <vxe-table-column
        field="clientName"
        title="客户名称"
        :filters="filterclientName"
      ></vxe-table-column>
      <vxe-table-column
        field="addTime"
        title="日期"
        width="110"
      ></vxe-table-column>
      <vxe-table-column field="note" title="摘要"></vxe-table-column>

      <vxe-table-column field="debiteAmount" title="借方金额（应收）">
        <template slot-scope="{ row }">
          <span>{{ row.debiteAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>

      <vxe-table-column field="creditAmount" title="贷方金额（已收）">
        <template slot-scope="{ row }">
          <span>{{ row.creditAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>

      <vxe-table-column field="balanceAmount" title="余额">
        <template slot-scope="{ row }">
          <span>{{ row.balanceAmount | formatMoney }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-modal
      v-model="isShowPaymentDetail"
      width="1300"
      height="660"
      resize
      remember
      title="收付款详情"
    >
      <payment-detail
        :cate="'Collection'"
        :isShow="isShowPaymentDetail"
        :chainId="chainId"
        ref="paymentDetail"
        @close="isShowPaymentDetail = false"
        @init="init"
      ></payment-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowBuyerReceivingDetail"
      width="1300"
      height="660"
      resize
      remember
      title="结算详情"
    >
      <buyer-receiving-detail
        ref="buyerReceivingDetail"
      ></buyer-receiving-detail>
    </vxe-modal>
    <vxe-modal
      v-model="isShowCarryOverDetail"
      title="结转详情"
      width="1300"
      height="460"
      resize
      remember
    >
      <carry-over-detail
        :isShow="isShowCarryOverDetail"
        ref="carryOverDetail"
        @close="isShowCarryOverDetail = false"
      ></carry-over-detail>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { timeFormatDate } from "@/filters/time";
import { numberToCurrency } from "@/filters/type";
import PaymentDetail from "@/views/payment/CollectionDetail.vue";
import BuyerReceivingDetail from "../../../views/receiving/BuyerReceivingDetail";
import {
  paymentFooter,
  isEmpty,
  goReceiveGoods,
  getFilterObj,
} from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import CarryOverDetail from "@/views/payment/CarryOverDetail.vue";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  components: {
    PaymentDetail,
    BuyerReceivingDetail,
    CarryOverDetail,
  },
  props: {
    id: String,
    pageTab: String,
    chainId: Number,
  },
  mixins: [getAuthOrization,openProcedureDetail],
  data() {
    return {
      loading: false,
      collectionListData: [],
      isShowPaymentDetail: false,
      isShowBuyerReceivingDetail: false,
      isShowCarryOverDetail: false,
      filterOwnName: [],
      filterclientName: [],
    };
  },
  watch: {
    // id(nv, ov) {
    //   if (nv !== ov && nv !== undefined) {
    //     this.getCollectionListData();
    //   }
    // },
    pageTab() {
      this.pageTab === "tab4" ? this.getCollectionListData() : "";
    },
  },
  // activated() {
  //   // this.getCollectionListData();
  //   this.$bus.$on("orderDetailRenovate", (data) => {
  //     data === true ? this.getCollectionListData() : "";
  //   });
  // },
  methods: {
    init() {
      this.getCollectionListData();
    },
    async getCollectionListData() {
      this.filterOwnName = [];
      this.filterclientName = [];
      if (isEmpty(this.id)) return;
      this.loading = true;
      let res = await $api.payments.request("queryPaymentsBuyerList", {
        ordersId: this.id,
        orderBy: 3,
        isDesc: 0,
        ordersType: 1,
      });
      if (res.status === 1) {
        let collectionListData = res.data.rows;
        const xTable = this.$refs.xTable;
        const ownNameColumn = xTable.getColumnByField("ownName");
        const clientNameColumn = xTable.getColumnByField("clientName");

        collectionListData.map((i) => {
          getFilterObj(this.filterOwnName, i.ownName);
          getFilterObj(this.filterclientName, i.clientName);
          i.addTime = timeFormatDate(i.addTime);
          if (i.paymentsState === 1) {
            i.paymentsNum = i.receiveNum;
          }
        });
        // 修改条件之后，需要手动调用 updateData 处理表格数据
        // 修改筛选列表，并默认设置为选中状态
        xTable.setFilter(ownNameColumn, this.filterOwnName);
        xTable.setFilter(clientNameColumn, this.filterclientName);
        xTable.updateData();
        this.collectionListData = collectionListData;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    footerMethod({ columns, data }) {
      return paymentFooter({ columns, data });
    },
    viewCarryOverDetail(id) {
      this.isShowCarryOverDetail = true;
      this.$refs.carryOverDetail.initDetail(id);
    },
    cellClick(e) {
      let field = e.column.property;
      if (field === "paymentsNum") {
        if (e.row.sourceType === 6) {
          // 打开结转流程
          this.viewCarryOverDetail(e.row.id);
        } else {
          if (e.row.paymentsState === 2) {
            if (!this.isHavePermission('PaymentsBuyer')){
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！"
              });
              return ;
            }
            this.isShowPaymentDetail = true;
            this.$refs.paymentDetail.init(e.row.id);
          } else {
            if (!this.isHavePermission('buyer:ReceDetail')){
              this.$Message["info"]({
                background: true,
                content: "对不起，您没有该权限！"
              });
              return ;
            }
            this.isShowBuyerReceivingDetail = true;
            this.$refs.buyerReceivingDetail.getReceivingDetail({
              id: e.row.receiveGoodsId,
            });
          }
        }
      }
    },
  },
};
</script>

<style>
</style>